import Yup from 'yup';

import { requiredStringType, requiredTextType } from './validationTypes';

const executiveType = Yup.object().shape({
  name: requiredStringType,
  bio: requiredTextType
});

export const cardSchema = Yup.object().shape({
  allocatorProfile: Yup.object().shape({
    aumRange: requiredStringType,
    employerType: requiredStringType,
    location: requiredStringType,
    fundManager: requiredStringType,
    bio: requiredTextType.max(1250, 'Description cannot be greater than 1,250 characters')
  })
});

export const executiveManagementSchema = Yup.object().shape({
  allocatorProfile: Yup.object().shape({
    executives: Yup.array().of(executiveType)
  })
});
